/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GET_ASSET_DETAIL } from "../pages/SoldAssetDetail/graphql/sold-asset-detail.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { useAsset} from "../pages/SoldAssetDetail/provider"
import {SOUND ,VIDEO} from "../assets";
import { toast } from "react-hot-toast";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";

const is = require("is_js");


const MODULE_NAME = "SoldAssetDetailService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class SoldAssetDetailService {
    private static instance: SoldAssetDetailService;
    private vapp: VApplication;
    private imageServer;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.imageServer = props?.imageServer;
    }
    public static getInstance(props: any = {}): SoldAssetDetailService {
        if (!SoldAssetDetailService.instance) {
            SoldAssetDetailService.instance = new SoldAssetDetailService(props);
        }
        return SoldAssetDetailService.instance;
    }
    
    _getAxButtons(resData: any) {
        let _buttons: any = [];
        console.log("ma",resData)

        if (resData) {
            _buttons.push({
                title: "View Proof of Transaction",
                link: resData
            })
        }

      

        return _buttons;
    }

    _findPrice(price: any[]) {
        let _price =
            is.array(price) &&
            price.map((item) => {
                return {
                    price: `${item?.amount} ${item?.currency}`,
                };
            });

        return _price;
    }

    _getImages(data: any,media:any , type:string) {

        // const getassetsDetailService = ClaimAssetDetailService.getInstance();
        const imgUrl = data?.img;
        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
        const imgBBformat = imgUrl?.split('/');
        const ibbFormat = imgBBformat[imgBBformat.length-3]
     
        let _imgF;
         if(ibbFormat === "i.ibb.co"){
            // _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
            _imgF = data?.img
         
         } 
         else {
            //  _imgF = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
            _imgF = data?.img
         }
         let _img;

         if(type === "audio"){
             _img = {
                original: data?.thumbnail ?? SOUND,
                thumbnail:data?.thumbnail ?? SOUND,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                type: "audio",
                 embedUrl: data?.img,
            }
         }
         if(type === "video"){
            _img = {
               original: data?.thumbnail ?? VIDEO,
               thumbnail: data?.thumbnail ?? VIDEO,
               thumbnailHeight: "70",
               thumbnailClass: "image-thumb",
               type: "video",
                embedUrl: data?.img,
           }
        }
         if(type === "image"){
            _img = {
                original: _imgF,
                thumbnail: _imgF,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            }
         }
             
       
        let _data = media?.map((item: any) => {
            console.log("insidde",item)

            const imgUrl = item?.src;
            const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
            const imgBBformat = imgUrl?.split('/');
            const ibbFormat = imgBBformat[imgBBformat.length-3]
         
            let _imgM;
             if(ibbFormat === "i.ibb.co"){
                // _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                _imgF = imgUrl
             
             } 
             else {
                //  _imgM = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
                _imgF = imgUrl
             }

            //    const uriType = ele?.uri.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0]
             const assetType = item?.type?.substring(0, item?.type?.indexOf('/'))
             // const assetType;
             let selectThumbnail;
             if(assetType === "video"){
                 selectThumbnail = VIDEO
             } else if( assetType === "audio"){
                 selectThumbnail = SOUND
             } else {
                 selectThumbnail = imgUrl
             }

        
             
          
  
            return {
                // ...item,
                original: selectThumbnail,
                    thumbnail: selectThumbnail,
                    thumbnailHeight: "70",
                    thumbnailClass: "image-thumb",
                    embedUrl: imgUrl,
                    type: assetType,
            };
        });
        console.log("IMG_DETAIL",[_img,..._data])

        let _images = [_img,..._data]
        return _images;

       
    }
    
    _getMeta(data: any[], digitalTwin: string) {
        let _meta = [];

        data?.map((item: any) => {
            _meta.push({
                key: item?.name,
                value: item?.val,
                disp_type: item?.disp_type,
            });
        });
        

        _meta.push({
            key: "Digital Twin",
            value: digitalTwin,
        });

        return _meta;
    }

    // getUserName(item){

    // }

    async getSoldAssetDetail(assetId: string) {
        
        const {group,id,store} =useAsset();

        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_DETAIL,
                    variables: {
                        tokenId:assetId,
                        storeId:store,
                        tokenGroup:group,
                    },
                    fetchPolicy: 'network-only'
                });
                if (res) {
                    let _data = res?.data?.getAsset
                console.log("SOLDASSET",_data )
                    let _found = {
                        idx: _data?.idx,
                        title: _data?.title,
                        subtitle: _data?.subtitle,
                        tokenId: _data?.serialNo,
                        serialNo: _data?.serialNo,
                        networkType: _data?.networkType,
                        tag: _data?.tag?.toUpperCase(),
                        category: _data?.tag?.toLowerCase(),
                        price: _data?.price,
                        meta: this._getMeta(_data?.attrs, _data?.digitalTwin),
                        info:this._getAxButtons(_data?.tx_proof),
                        createdBy: {
                            userName: _data?.creator?.name,
                            userId: _data?.creator?.name,
                            // link: "/swiss-timing",
                            authProofUrl:res?.data?.viewInIpfs 
                        },
                        ownedBy:{
                            userName: _data?.owner?.name,
                            userId: _data?.owner?.name,
                          
                           
                        },
                        nftProvenance: _data?.nftProvenance?.map(item => {
                            console.log("nftprov",item)
                            return ({
                                title: item?.title,
                                profile: {
                                    // userName: item?.from?.name ?? item?.to?.name ,
                                    userName: item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.name : item?.from?.name,
                                    fromAddress:item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.address : item?.from?.address,
                                    link: item?.form?.link,
                                    tx_proof:item?.tx_proof,
                                    
                                    // toAddress:item?.title !== "Owned By" ? item?.to?.address : null,
                                    authProofUrl: res?.data?.viewInIpfs  
                                },
                                eventOccurence: {
                                    date:item?.date
                                },
                                meta: {
                                    ...item?.meta
                                }
                            })
                        }),
                        nftSMProvenance : _data?.nftProvenance?.map((item) => {
                            return {
                                data: [
                                    {
                                        tag: item?.from?.name ?? item?.to?.name,
                                        title: item?.title,
                                        subtitle: item?.from?.name ?? item?.to?.name,
                                        link: item?.form?.link,
                                         price: item?.meta?.priceInFiat ??item?.meta?.priceInCrypto ,
                                        date: item?.date,
                                        tx_proof:item?.tx_proof,
                                        fromAddress:item?.from?.address,
                                        toAddress:item?.to?.address,
                                        authProofUrl: res?.data?.viewInIpfs 
                                    },
                                ],
                            };
                        }),
                        images: this._getImages(_data, _data?.media, _data?.type),
                        // timeline: _data?.timeline?.map((item:any)=>{
                        //     return({
                        //         title: item?.event,
                        //         description:[
                        //             // {
                        //             //     displayType: "date",
                        //             //     key: "Listed At",
                        //             //     value: item?.date?.toISOString()
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "From",
                        //             //     value: item?.from?.value,
                        //             //     link: item?.from?.link
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "To",
                        //             //     value: item?.to?.value,
                        //             //     link: item?.to?.link
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "Proof of List",
                        //             //     value: item?.proof?.value,
                        //             //     link: item?.proof?.link
                        //             // }
                        //         ]
                        //     })
                        // }),
                    }
                    if (_found) {
                        return _found;
                    }

                }
                // log.success(SERVICE_NAME, "get asset detail result: ", res);
                // // return res?.data?.getAssets;
                // return res?.data?.getAsset;
            }
        } catch (err) {
           getErrorMessage(err);
        }
    }
}
